import Mock from 'mockjs'

const mockData = Mock.mock({
  'data|3-6': [{
    'name': '@NAME',
    'creatDate': '@DATE',
    'address': '@CITY',
    'zip': '@ZIP'
  }]
})

export default {
  data: null,
  columns: [
    {
      label: '主办方',
      prop: 'sysOrgName'
    },
    {
      label: '加盟费',
      prop: 'initialFeeModels'
    },
    {
      label: '缴费方式触发限额',
      prop: 'limitFeeModels'
    },
  ]
}
